import type { ReactNode } from "react";

const QUESTIONS: { q: string; a: ReactNode }[] = [
  {
    q: "Do I keep my number?",
    a: (
      <p>
        You get a new number from us. Put it wherever customers find you, or forward your
        current number to it. We can't move an existing number across yet.
      </p>
    ),
  },
  {
    q: "Which rental systems does it work with?",
    a: (
      <p>
        Current RMS, Rentman, Booqable and HireHop, alongside Google Calendar, Outlook Calendar
        and Xero.{" "}
        <a className="ilink" href="/integrations">
          See every integration
        </a>
        , and if yours isn't there, ask us.
      </p>
    ),
  },
  {
    q: "When does the receptionist reply?",
    a: (
      <p>
        Whenever your team can't get to a call or a text. A call goes to it when nobody has
        picked up in the time you set, from 5 to 60 seconds. It can be on at every hour, or
        only at set times and days, and all day on public holidays. When it's off, callers can
        leave a voicemail.
      </p>
    ),
  },
  {
    q: "What if it gets something wrong?",
    a: (
      <p>
        Nothing a customer asks for by call or text changes a booking until your team accepts
        it, and the recording, transcript or messages are there to check it against.
      </p>
    ),
  },
  {
    q: "What does it say about prices?",
    a: (
      <p>
        Only what you let it. Separate switches cover your catalogue, an item's day rate, and
        jobs already on file, and there's a box for anything else you want it to be able to
        say. It never works out a total. That comes with your quote.
      </p>
    ),
  },
  {
    // The Safe Browsing answer: this domain sends links on another company's
    // behalf, so it has to say plainly who runs it and what it never asks for.
    q: "Got a link from us?",
    a: (
      <>
        <p>
          Quotes, approvals and invoices on this domain are sent by HireOS for the rental
          company named on the page. The name and bank details you see are that company's, not
          ours. We are not the company you are hiring from, and we never take payment.
        </p>
        <p>
          We will never ask for a password, a card number, or your banking login. If a page
          claiming to be us does, don't fill it in. Email hello@loony.io and we'll check
          it.
        </p>
      </>
    ),
  },
];

/** The plus that becomes a minus once its question is open. */
function PlusMinus() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <g filter="url(#ink-xs)">
        <path d="M4 12h16" />
        <path className="v" d="M12 4v16" />
      </g>
    </svg>
  );
}

export function Faq() {
  return (
    <section className="sec" id="faq">
      <div className="faq">
        <h2>
          Frequently asked
          <br />
          questions
        </h2>
        <div>
          {QUESTIONS.map(({ q, a }) => (
            <details key={q}>
              <summary>
                {q}
                <PlusMinus />
              </summary>
              {a}
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
